// extracted by mini-css-extract-plugin
module.exports = {"default":"styles_default__0ETG9","left":"styles_left__KuMBt","right":"styles_right__TheP3","top":"styles_top__Rz42U","bottom":"styles_bottom__LQZLb"};